
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --heading-color:var(--brand-white);
}

.anchor-block{
  background-color:var(--brand-primary-dark-blue);
  background-color:var(--background-color, var(--brand-primary-dark-blue));
}

.inner{
  display:flex;
  flex-direction:column;
  padding:var(--spacing-5);
}

@media (min-width: 1024px){

.inner{
    flex-direction:row;
    justify-content:space-between
}
  }

.btn{
  width:100%;
}

@media (min-width: 1024px){

:host([variant='stacked']) .anchor-block{
      padding:var(--spacing-12)
  }
    }

:host([variant='stacked']) .inner{
    gap:var(--spacing-10);
    flex-direction:column;
  }

:host([variant='stacked']) ul{
    display:grid;
    gap:var(--spacing-4);
  }

@media (min-width: 1024px){

:host([variant='stacked']) ul{
      grid-template-columns:repeat(3, 1fr);
      grid-auto-rows:minmax(0, auto);
      grid-auto-flow:dense
  }
    }

@media (min-width: 1024px){

:host([variant='inline']) .anchor-block{
      padding:5.625rem var(--spacing-5)
  }
    }

:host([variant='inline']) .inner{
    gap:var(--spacing-4);
  }

:host([variant='inline']) .left-col{
    display:flex;
    align-items:center;
  }

@media (min-width: 1024px){

:host([variant='inline']) .left-col,
  :host([variant='inline']) .right-col{
      width:50%
  }
    }

:host([variant='inline']) ul{
    display:flex;
    flex-direction:column;
    gap:var(--spacing-4);
  }
`;